import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'sag-ui-date-range-picker-demo',
  template: `<div style="height: 500px;">
    <sag-ui-date-range-picker
      label="When are you on vacation?"
      placeholder="MM/DD/YYYY - MM/DD/YYYY"
      [formGroup]="formGroup"
      formControlNameStart="startDate"
      formControlNameEnd="endDate"
    ></sag-ui-date-range-picker>
  </div>`,
  styleUrls: [],
})
export class DateRangePickerDemoComponent {
  formGroup = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
}
